import React from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css';

function Homepage() {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            ⚡ Enerji Takip ile <br />
            <span className="highlight">Akıllı Enerji Yönetimi</span>
          </h1>
          <p className="hero-subtitle">
            Gerçek zamanlı izleme, IoT entegrasyonu, yapay zeka destekli analiz ve kapsamlı raporlama ile 
            enerji tüketiminizi optimize edin. 15+ yıllık deneyimle 50+ şehirde hizmet veriyoruz.
          </p>
          <div className="hero-actions">
            <Link to="/dashboard" className="cta-primary">
              🚀 Hemen Başla
            </Link>
            <Link to="/features" className="cta-secondary">
              📋 Özellikleri İncele
            </Link>
          </div>
        </div>
        <div className="hero-image">
          <div className="energy-visual">
            <div className="energy-circle">
              <div className="energy-pulse"></div>
              <span className="energy-text">%25 Tasarruf</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Preview */}
      <section className="features-preview">
        <div className="container">
          <h2 className="section-title">Neden Enerji Takip?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Gerçek Zamanlı İzleme</h3>
              <p>Enerji akışı, gerilim, akım ve güç faktörlerini saniyelik olarak izleyin. Canlı dashboard ile hızlı karar alma.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔔</div>
              <h3>Akıllı Alarm Sistemi</h3>
              <p>Kritik durumlarda anında bildirim. Enerji anomalileri ve eşik değer aşımlarında otomatik uyarı sistemi.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🤖</div>
              <h3>Yapay Zeka Analizi</h3>
              <p>AI destekli anomali tespiti ve trend analizi ile gelecek tüketim tahminleri yapın.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌐</div>
              <h3>IoT Entegrasyonu</h3>
              <p>Sensör, röle, akıllı priz ve kompanzasyon cihazlarını tek platformda yönetin.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Detaylı Raporlama</h3>
              <p>Enerji kalitesi, harmonik analizi, jeneratör demand ve verimlilik raporları.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏢</div>
              <h3>Tesis Yönetimi</h3>
              <p>Çoklu tesis ve lokasyon yönetimi. Harita üzerinde konum bazlı enerji profilleri.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number">15+</div>
            <div className="stat-label">Yıllık Deneyim</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">1000+</div>
            <div className="stat-label">Aktif Müşteri</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">50+</div>
            <div className="stat-label">Şehir</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">500+</div>
            <div className="stat-label">Tamamlanan Proje</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">%99.9</div>
            <div className="stat-label">Uptime</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Teknik Destek</div>
          </div>
        </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Hemen Başlayın!</h2>
            <p>Enerji tasarrufu yolculuğunuza bugün başlayın ve farkı hissedin.</p>
            <Link to="/dashboard" className="cta-button">
              🎯 Ücretsiz Deneyin
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Homepage;
